module.exports = __webpack_public_path__ + "static/media/Crosswinds-West-Master-Deed-By-laws.11e3b267.pdf";